import RadioGroup from "@mui/material/RadioGroup";
import { ComponentProps } from "../types";

function Component({ component }: ComponentProps) {
	return <RadioGroup key={component.id} />;
}

export default Component;
